import {Typography} from '@mui/material';
import React from 'react';

export const ResultLabel = React.memo(
   ({renderIf = true, children}: {renderIf?: boolean; children: React.ReactNode}) => {
      return renderIf ? <Typography>{children}</Typography> : null;
   }
);
